/**
 * ScriptDownloadButton — baixa o script Python de importação (RF-M2-008).
 * O download exige JWT admin, portanto busca o arquivo via fetch autenticado (o
 * token viaja no header, não é possível um <a href> simples) e dispara o save.
 */

import { useCallback, useState } from 'react';
import { useServices } from '../contexts/ServicesContext';
import { useAuth } from '../contexts/AuthContext';

export function ScriptDownloadButton(): JSX.Element {
  const { cargas, apiBaseUrl } = useServices();
  const { token } = useAuth();
  const [erro, setErro] = useState(false);
  const [baixando, setBaixando] = useState(false);

  const baixar = useCallback(async () => {
    setErro(false);
    setBaixando(true);
    try {
      const resp = await fetch(cargas.scriptDownloadUrl(apiBaseUrl), {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: 'omit',
      });
      if (!resp.ok) {
        throw new Error('download falhou');
      }
      const blob = await resp.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'importar_acervo.py';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      // Erro genérico — sem detalhes internos (RN-GLOBAL-004).
      setErro(true);
    } finally {
      setBaixando(false);
    }
  }, [cargas, apiBaseUrl, token]);

  return (
    <div>
      <button type="button" className="btn btn-ghost" onClick={baixar} disabled={baixando}>
        {baixando ? 'Baixando…' : 'Baixar script de importação'}
      </button>
      {erro && <p className="notice" style={{ marginTop: 8 }}>Não foi possível baixar o script.</p>}
    </div>
  );
}
